import { UserRole } from '@assessments/shared'

export { canEditAssessment, canViewAssessment, isEthisphereAdminOnly } from '@assessments/shared'

/**
 * The respondent roles, for the app-shell gate — which needs a role list, not a
 * predicate. Org View Only (`UserRole.User`) belongs here: it views read-only.
 */
export const VIEWER_ROLES: UserRole[] = [UserRole.CompanyAdministrator, UserRole.User]
